<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.orderNO" placeholder="订单编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.mallOrderNO" placeholder="商城订单号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.userPhone" placeholder="用户手机"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.provinceIds" clearable style="width:150px;" placeholder="用户省份">
                        <el-option
                                v-for="item in provinces"
                                :key="item.region_id"
                                :label="item.region_name"
                                :value="item.region_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            placeholder="选择日期时间"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.finishCode" placeholder="完工码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.masterId" placeholder="工程师ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.userName" placeholder="用户姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getOrders">查询</el-button>
                </el-form-item>
                <el-form-item v-if="accountType!=0">
                    <el-button type="primary" @click="handleAdd">新增</el-button>
                </el-form-item>
            </el-form>
        </el-col>


        <el-table :data="orders" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%;">

            <el-table-column type="expand">
                <template slot-scope="props">
                    <!-- <el-row>
                         <el-col :span="5">
                             <el-tag type="success">用户信息</el-tag>
                         </el-col>
                         <el-col :span="5">
                             <el-tag type="success">下单人信息</el-tag>
                         </el-col>
                         <el-col :span="5">
                             <el-tag type="success">安装人信息</el-tag>
                         </el-col>
                         <el-col :span="5">
                             <el-tag type="success">订单产品详情</el-tag>
                         </el-col>
                         <el-col :span="4">
                             <el-tag type="success">订单状态</el-tag>
                         </el-col>


                     </el-row>-->
                    <el-row>
                        <el-col :span="5">
                            <el-form label-position="left" label-width="120px" class="demo-table-expand">
                                <el-form-item label="商城用户ID">
                                    <span>{{ props.row.mallUserId}}</span>
                                </el-form-item>
                                <el-form-item label="商城订单号">
                                    <span>{{ props.row.mallOrderNO}}</span>
                                </el-form-item>

                                <el-form-item label="用户姓名">
                                    <span>{{ props.row.userName }}</span>
                                </el-form-item>
                                <el-form-item label="用户电话">
                                    <span>{{ props.row.userPhone }}</span>
                                </el-form-item>
                                <el-form-item label="详细地址">
                                    <span>{{ props.row.userAddress }}</span>
                                </el-form-item>
                            </el-form>

                        </el-col>
                        <el-col :span="5">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="商户详情">
                                    <el-button type="text" size="small"
                                               @click="queryMerchant(props.row)">点击查看
                                    </el-button>
                                </el-form-item>
                                <el-form-item label="付款方式">
                                    <span>{{ props.row.payType | formatPayType}}</span>
                                </el-form-item>
                                <el-form-item label="物流信息">
                                    <span>{{ props.row.logistics }}</span>
                                </el-form-item>
                                <el-form-item label="订单备注">
                                    <span>{{ props.row.orderRemark }}</span>
                                </el-form-item>
                                <el-form-item label="用户地区">
                                    <span>{{ props.row.regionAddress}}</span>
                                </el-form-item>

                            </el-form>
                        </el-col>
                        <el-col :span="5">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="指派员工">

                                    <el-button v-if="typeof props.row.worker!=='undefined'" type="text" size="small"
                                               @click="queryCommonUser(props.row)">点击查看
                                    </el-button>

                                    <span v-else>未派单</span>
                                </el-form-item>
                                <el-form-item label="工程师详情">
                                    <el-button v-if="typeof props.row.masterId!=='undefined'" type="text" size="small"
                                               @click="queryMasterUser(props.row)">点击查看
                                    </el-button>
                                    <span v-else>未指派</span>
                                </el-form-item>
                                <el-form-item label="安装时间">
                                    <span>{{ props.row.installTime }}</span>
                                </el-form-item>
                                <el-form-item label="安装备注">
                                    <span>{{ props.row.productInfo }}</span>
                                </el-form-item>
                                <el-form-item label="安装图片">
                                    <el-button type="text" size="small"
                                               @click="queryImage(props.row)">点击查看
                                    </el-button>
                                </el-form-item>

                            </el-form>
                        </el-col>
                        <el-col :span="5">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="车型">
                                    <span>{{ props.row.carType }}</span>
                                </el-form-item>
                                <el-form-item label="产品信息">
                                    <span>{{ props.row.productInfo }}</span>
                                </el-form-item>
                                <el-form-item label="订单费用">
                                    <span>{{ props.row.orderMoney | formatMoney}}</span>
                                </el-form-item>
                               <!-- <el-form-item label="安装费用">
                                    <span>{{ props.row.installMoney | formatMoney}}</span>
                                </el-form-item>
                                <el-form-item label="平台费用">
                                    <span>{{ props.row.platformMoney | formatMoney}}</span>
                                </el-form-item>
                                <el-form-item label="补贴费用">
                                    <span>{{ props.row.subsidyMoney | formatMoney}}</span>
                                </el-form-item>-->

                                <el-form-item label="补贴备注">
                                    <span>{{ props.row.subsidyremark}}</span>
                                </el-form-item>

                            </el-form>
                        </el-col>
                        <el-col :span="4">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="订单状态">
                                    <span>{{ props.row.state | formatOrderStatus}}</span>
                                </el-form-item>
                                <el-form-item label="退订备注">
                                    <span>{{ props.row.cancelRemark}}</span>
                                </el-form-item>
                                <el-form-item label="订单评分">
                                    <span>{{ props.row.score }}</span>
                                </el-form-item>
                                <el-form-item label="订单评价">
                                    <span>{{ props.row.state }}</span>
                                </el-form-item>
                                <el-form-item label="完工码">
                                    <span>{{ props.row.finishCode }}</span>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="orderNO" label="订单编号" style="text-align: center">
            </el-table-column>
            <el-table-column prop="merchantId" label="商户ID" :formatter="formatMerchantId">
            </el-table-column>
            <el-table-column prop="merchantPayState" label="支付状态" style="text-align: center" width="100"
                             :formatter="formatMerchantPayState">
            </el-table-column>
            <!--<el-table-column prop="state" label="订单状态" width="100" :formatter="formatOrderStatus">
            </el-table-column>-->
            <el-table-column prop="orderTime" label="订单时间" width="180">
            </el-table-column>
            <el-table-column prop="orderMoney" label="订单费" width="80" :formatter="formatMoney">
            </el-table-column>
            <el-table-column prop="installMoney" label="安装费" v-if="accountType==0" width="80" :formatter="formatMoney">
            </el-table-column>
            <el-table-column prop="subsidyMoney" label="补贴费" v-if="accountType!=2" width="80" :formatter="formatMoney">
            </el-table-column>
            <!-- <el-table-column prop="platformMoney" label="补贴费" width="80" :formatter="formatMoney">
             </el-table-column>-->

            <el-table-column label="操作">
                <template slot-scope="scope">

                    <el-button type='primary' size="small"
                               @click="showEditOrder(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type='danger' size="small" v-if="accountType!=2"
                               @click="recoverOrder(scope.$index, scope.row)">恢复订单
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑订单" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" ref="editForm">
                <el-row v-if="accountType==1">
                    <el-col>
                        <el-form-item label="所属商户" class="require">
                            <el-select style="width:100%" filterable v-model="editForm.merchantId"
                                       placeholder="请选择商户">
                                <el-option
                                        v-for="item in merchant"
                                        :key="item.userId"
                                        :label="item.name"
                                        :value="item.userId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="产品信息" class="require">
                            <el-input v-model="editForm.productInfo" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车型">
                            <el-input v-model="editForm.carType" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="订单费用" class="require">
                            <el-input v-model="editForm.orderMoney" placeholder="单位:元" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="安装费用">
                            <el-input v-model="editForm.installMoney" placeholder="单位:元（可不填）"
                                      auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户姓名" class="require">
                            <el-input v-model="editForm.userName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号码" class="require">
                            <el-input v-model="editForm.userPhone" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="地区" class="require">
                            <el-cascader style="width:255px"
                                         v-model="regionId"
                                         placeholder="不选择则使用之前地区"
                                         :options="addProvinces"
                                         @active-item-change="select_ChangeEvent"
                                         :props="props">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" class="require">
                            <el-input v-model="editForm.userAddress" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商城ID">
                            <el-input v-model="editForm.mallUserId" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商城订单号">
                            <el-input v-model="editForm.mallOrderNO" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="物流信息">
                            <el-input v-model="editForm.logistics" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="订单备注">
                            <el-input type="textarea" v-model="editForm.orderRemark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="安装备注">
                            <el-input type="textarea" v-model="editForm.installRemark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--图片展示界面-->
        <el-dialog title="查看图片" v-model="queryImageVisible" :close-on-click-modal="false" customClass="customWidth">

            <el-form label-width="120px" style="width:100%">
                <el-form-item label="门头相片">

                    <img :src="item" v-for="item in images"/>

                </el-form-item>
            </el-form>
        </el-dialog>


    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";
    import {TMap} from '../../api/map'
    import gongImg from '@/assets/gong.png'
    import dingImg from '@/assets/ding.png'

    export default {
        data() {
            return {
                accountType: sessionStorage.getItem('type'),
                filters: {
                    orderNO:'',
                    state: -1,
                    masterId: '',
                    finishCode: '',
                    userPhone: '',
                    provinceIds: '',
                    orderStartTime: '',
                    orderEndTime: '',
                    mallOrderNO: '',
                    userName:''

                },
                orders: [],
                total: 0,
                rowCount: 30,
                pageNO: 1,
                orderType: data.orderType,
                listLoading: false,
                sels: [],

                provinces: [],
                pickerOptions: data.pickerOPtions,
                date: '',

                editFormVisible: false,
                editLoading: false,
                editForm: {
                    orderMoney: '',
                    installMoney: '',
                    merchantId: '',
                    orderRemark: '',
                    carType: '',
                    productInfo: '',
                    userName: '',
                    userPhone: '',
                    userProvince: '',
                    userCity: '',
                    userArea: '',
                    userAddress: '',
                    mallUserId: '',
                    mallOrderNO: '',
                    logistics: '',
                    installRemark: ''

                },
                images: [],
                queryImageVisible: false,
                addProvinces: [],
                regionId: [],
                props: {
                    value: 'region_id',
                    label: 'region_name',
                    children: 'cities'
                },
                masterUsers: [],
                merchant: [],
                confirmAssignVisible: false,
                confirmAssignForm: {
                    installMoney: 0,
                    masterId: ''
                }

            }
        },


        filters: {
            formatMoney: function (value, discount) {
                return value / 100;
            },
            formatOrderStatus(value, discount) {
                return data.orderStatus[value + 1]
            },
            formatMerchantPayState(value, discount) {
                return data.merchantPayState[value]
            },
            formatMasterPayState(value, discount) {
                return data.masterPayState[value]
            }


        },


        methods: {

            formatMerchantPayState(row, column) {
                return data.merchantPayState[row.merchantPayState]
            },

            formatServiceType(row) {
                return data.serviceType[row.serviceType];
            },
            formatOrderStatus(row, column) {
                return data.orderStatus[row.state + 1]
            },

            formatMerchantId(row, column) {
                return `${row.merchantId}-${row.merchantName}`
            },
            formatAddress(row, column) {
                return `${row.userProvince} ${row.userCity} ${row.userArea} ${row.userAddress}`;
            },
            formatMoney(row, column) {

                if (row.orderMoney && column.label == '订单费') {
                    return row.orderMoney / 100;
                } else if (row.installMoney && column.label == '安装费') {
                    return row.installMoney / 100;
                } else if (row.subsidyMoney && column.label == '补贴费') {
                    return row.subsidyMoney / 100;
                }

            },


            showEditOrder(inde, row) {

                this.editFormVisible = true;
                this.regionId = [];


                util.getArea(this, '').then(res => {
                    for (let i = 0; i < res.data.length; i++) {
                        this.addProvinces = res.data;
                        this.$set(this.addProvinces[i], 'cities', []) // right
                    }
                }).then(() => {

                    let para = {
                        userType: 2
                    };
                    NProgress.start();
                    let url = 'user/getByUserType.do';
                    requestPost(this, url, para).then((res) => {

                        if (res != '') {

                            this.merchant = res.data;
                        }
                        NProgress.done();
                        this.editForm = Object.assign({}, row);
                        this.editForm.orderMoney = row.orderMoney / 100;
                        this.editForm.installMoney = row.installMoney / 100;
                    });
                });
            },

            editSubmit() {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.editForm);
                            if (this.regionId.length > 0) {
                                para.userProvince = this.regionId[0];
                                para.userCity = this.regionId[1];
                                para.userArea = this.regionId[2];
                            }
                            para.orderMoney = this.editForm.orderMoney * 100;
                            para.installMoney = this.editForm.installMoney * 100;
                            console.log(para);
                            let url = 'order/update.do';
                            requestPost(this, url, para).then((res) => {
                                this.editLoading = false;
                                NProgress.done();
                                if (res !== '') {
                                    util.successTip(this);
                                    this.$refs['editForm'].resetFields();
                                    this.editFormVisible = false;
                                    this.filters.userPhone = this.editForm.userPhone;
                                    this.getOrders();
                                }
                            });
                        });
                    }
                });
            },

            recoverOrder(index, row) {

                this.$confirm('确认恢复该订单吗?', '提示', {
                    type: 'warning'
                }).then(() => {

                    NProgress.start();
                    let para = {orderId: row.orderId};
                    let url = 'order/recovery.do';
                    requestPost(this, url, para).then((res) => {

                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getOrders();
                        }
                    });
                }).catch(() => {

                });

            },


            select_ChangeEvent(val) {

                if (val.length == 1) {
                    util.getArea(this, val[0]).then(res => {
                        this.addProvinces.map((value, i) => {
                            if (value.region_id === val[0]) {
                                if (!value.cities.length) {
                                    value.cities = res.data.map((value, i) => {
                                        return {
                                            region_id: value.region_id,
                                            region_name: value.region_name,
                                            cities: []
                                        }
                                    })
                                }
                            }
                        })
                    })
                } else if (val.length === 2) {
                    util.getArea(this, val[1]).then(res => {
                        this.addProvinces.map((value, i) => {
                            if (value.region_id === val[0]) {
                                value.cities.map((value, i) => {
                                    if (value.region_id === val[1]) {
                                        if (!value.cities.length) {
                                            value.cities = res.data.map((value, i) => {
                                                return {
                                                    region_id: value.region_id,
                                                    region_name: value.region_name
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })
                    })

                }


            },

            queryMerchant: function (row) {
                this.$router.push({path: '/merchant', query: {merchantId: row.merchantId}})

            },
            queryCommonUser: function (row) {
                this.$router.push({path: '/worker', query: {workerId: row.workerId}})

            },

            queryMasterUser: function (row) {

                this.$router.push({path: '/masterUser', query: {masterId: row.masterId}})
            },

            queryImage: function (row) {
                if (typeof row.installPic != 'undefined' && row.installPic.length > 0) {
                    this.queryImageVisible = true;

                    this.images = row.installPic.split(";").map(function (value, i) {
                        return `../image/getByImageId.do?imageId=${value}`
                    });
                } else
                    this.$message({
                        message: '暂未上传图片',
                        type: 'error'
                    });
            },

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getOrders();
            },

            getOrders() {
                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };

                if (this.date != '') {
                    this.filters.orderStartTime = util.formatDate.format(new Date(this.date[0]), 'yyyy-MM-dd hh:mm:ss');
                    this.filters.orderEndTime = util.formatDate.format(new Date(this.date[1]), 'yyyy-MM-dd hh:mm:ss');
                }
                para = Object.assign(para, this.filters);

                this.listLoading = true;
                NProgress.start();
                let url = 'order/queryPage.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        this.total = res.total;
                        this.orders = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },

            selsChange: function (sels) {
                this.sels = sels;
            }

        },
        mounted() {
            this.getOrders();

        },
        activated: function () {

        },
        created() {
            let _this = this;
            util.getArea(this, '').then(res => {
                this.provinces = res.data;
            });
        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';

    .map {
        width: 100%;
        height: 400px;
    }

    .assignWidth {
        width: 1400px;
    }

</style>


// WEBPACK FOOTER //
// cancelOrder.vue?f7eefe1e